import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Registration } from '@telrun-client/_proxy/entities/registration.entity';
import { RegistrationEndpoint } from '@telrun-client/_proxy/endpoints/registration.endpoint';
import { PaymentRequestParams } from '@telrun-client/_proxy/params/paymentrequest.param';
import { Globals } from '@telrun-client/_globals';

class State extends BaseState {
    Registration: Registration;
    Url: SafeResourceUrl;
    VisibleLoadPanel: boolean = false;
    Success = false;
    ShowError = false;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-credit-card',
    styleUrls: ['./credit-card.component.scss'],
    templateUrl: './credit-card.component.html'
})
export class CreditCardComponent extends BasePageComponent<BaseEntity, State> {

    constructor(A: ServiceBagService,
        private registrationEndpoint: RegistrationEndpoint,
        private Sanitizer: DomSanitizer,
        private ref: ChangeDetectorRef) {
        super(A, 'CreditCardComponent', BaseEntity, State);
    }

    override OnInitComponent() {
        this.State.Registration = Globals.Registration;
        if (this.State.Registration == null) {
            this.Navigate(['/pages/registration']);
            return;
        }
        this.SendPaymentRequest();

        (window.document as any).OnSuccessfulPayment = (PrivateRequestID: string) => {
            this.OnSuccessfulPaymentHandler(PrivateRequestID);
        }
    }

    OnPrevious() {
        this.Navigate(['/pages/registration']);
    }

    private SendPaymentRequest() {
        let params = new PaymentRequestParams();
        params.RegistrationID = this.State.Registration.EntryID;

        this.Do(this.registrationEndpoint.SendPaymentRequest(params), false, (response) => {
            this.State.Url = this.Sanitizer.bypassSecurityTrustResourceUrl(response.Data);
        })
    }

    private OnSuccessfulPaymentHandler(PrivateRequestID: string) {
        this.State.VisibleLoadPanel = true;
        this.ref.detectChanges();

        let params = new PaymentRequestParams();
        params.PrivatePaymentRequestID = PrivateRequestID;

        this.Do(this.registrationEndpoint.ConfirmPaymentRequest(params), false, (response) => {            
            this.State.Url = undefined;
            this.State.VisibleLoadPanel = false;
            Globals.Registration = null;
            this.State.Success = true;
            this.State.Registration.ResultCardCode = response.Entity.ResultCardCode;
            if (response.Entity.ResultBillID == undefined) {
                this.State.ShowError = true;
                this.State.Success = false;
            }
            this.ref.detectChanges();
        }, (response) => {
            this.UI.StopMessage(response.ResponseMessage);
            this.State.VisibleLoadPanel = false;
            this.ref.detectChanges();
        });
    }

    get Message() {
        return  this.RC('txtSuccessMessage', this.State.Registration.ResultCardCode);            
    }
}
